import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CardButtonComponent } from '../../components/ui-components/buttons/card-button/card-button.component';
import { CardButtonBackground, CardButtonSize } from '../../components/ui-components/buttons/card-button/card-button.model';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, CardButtonComponent],
})
export class ReportsComponent {
  private router = inject(Router);

  CardButtonSize = CardButtonSize;
  CardButtonBackground = CardButtonBackground;

  goToMovementReport() {
    this.router.navigate(['/reports/movement-report']);
  }

  goToClosingReport() {
    this.router.navigate(['/reports/valuables-report']);
  }

  goToTransactionsListReport() {
    this.router.navigate(['/report', 'transactionsList']);
  }

  goToPosStateReport() {
    this.router.navigate(['/report', 'posState']);
  }

  goToPosBookReport() {
    this.router.navigate(['/report', 'posBook']);
  }

  
}
